module.exports = __webpack_public_path__ + "img/goose1.5f8a4aa1.jpg";